// removed by extract-text-webpack-plugin
module.exports = {"valign":"_3yY-KTXAS_kOYNTUPrvNjV","valignMiddle":"_2i-Ze7deduPr0D5E-j7t2B","valignBottom":"RXAh0Rgez_JhrOTHjaUrX"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Valign/style.css
// module id = 242
// module chunks = 37